export default {"src":"/_next/static/media/testimonials_dots.e68421e9.svg","height":503,"width":460,"blurWidth":0,"blurHeight":0};